import { render, staticRenderFns } from "./title_label.vue?vue&type=template&id=3ea0f6f5&"
import script from "./title_label.vue?vue&type=script&lang=js&"
export * from "./title_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports